export const iconFontAwesomeMoneyMoneyBillTrendUp = (
	<i className="fa-solid fa-money-bill-trend-up"></i>
);
